/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListShadowMCPInventoryUsersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListShadowMCPInventoryUsersRequest = {
  projectId: string;
  /**
   * Shadow MCP server URL to expand.
   */
  serverUrl: string;
  limit?: number | undefined;
  /**
   * Cursor for the next page of results.
   */
  cursor?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListShadowMCPInventoryUsersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListShadowMCPInventoryUsersSecurity$outboundSchema: z.ZodMiniType<
  ListShadowMCPInventoryUsersSecurity$Outbound,
  ListShadowMCPInventoryUsersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listShadowMCPInventoryUsersSecurityToJSON(
  listShadowMCPInventoryUsersSecurity: ListShadowMCPInventoryUsersSecurity,
): string {
  return JSON.stringify(
    ListShadowMCPInventoryUsersSecurity$outboundSchema.parse(
      listShadowMCPInventoryUsersSecurity,
    ),
  );
}

/** @internal */
export type ListShadowMCPInventoryUsersRequest$Outbound = {
  project_id: string;
  server_url: string;
  limit: number;
  cursor?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListShadowMCPInventoryUsersRequest$outboundSchema: z.ZodMiniType<
  ListShadowMCPInventoryUsersRequest$Outbound,
  ListShadowMCPInventoryUsersRequest
> = z.pipe(
  z.object({
    projectId: z.string(),
    serverUrl: z.string(),
    limit: z._default(z.int(), 50),
    cursor: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      serverUrl: "server_url",
      gramSession: "Gram-Session",
    });
  }),
);

export function listShadowMCPInventoryUsersRequestToJSON(
  listShadowMCPInventoryUsersRequest: ListShadowMCPInventoryUsersRequest,
): string {
  return JSON.stringify(
    ListShadowMCPInventoryUsersRequest$outboundSchema.parse(
      listShadowMCPInventoryUsersRequest,
    ),
  );
}
